import { render, staticRenderFns } from "./modalTransportOrderCtDetailPostpone.vue?vue&type=template&id=3408f548&scoped=true"
import script from "./modalTransportOrderCtDetailPostpone.vue?vue&type=script&lang=js"
export * from "./modalTransportOrderCtDetailPostpone.vue?vue&type=script&lang=js"
import style0 from "./modalTransportOrderCtDetailPostpone.vue?vue&type=style&index=0&id=3408f548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3408f548",
  null
  
)

export default component.exports